import { Observable } from 'rxjs';
import { ApiService } from './api';

export class Subscription {
  id!: string;
  name!: string;
}
export interface SubscriptionTiers {
  id: number;
  name: string;
  type: string;
}
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SubscriptionsService {

  path: string = '/api';

  constructor(private apiService: ApiService) { }

  getSubscriptionTiers(): Observable<SubscriptionTiers[]> {
    return this.apiService.get(`${this.path}/v2/subscription_tiers`);
  }
}
